import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TimerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timer"}/>
}
